import type { FC } from 'react';
import { useMatchScores } from '@mwl/core-lib';
import { PerfectScrollbarWithShadow } from '@/components/PerfectScrollbarWithShadow/PerfectScrollbarWithShadow';
import { useMediaWidthDown } from '@/hooks';
import { MatchScoreRow } from '../MatchScoreRow/MatchScoreRow';
import { MatchAdditionalSegments } from './components/MatchAdditionalSegments/MatchAdditionalSegments';
import { MobileMatchPeriodIcon } from './components/MobileMatchPeriodIcon/MobileMatchPeriodIcon';
import { gameEventIcons } from './MatchScores.constants';
import type { MatchScoresProps } from './MatchScores.types';
import styles from './MatchScores.module.scss';
export const MatchScores: FC<MatchScoresProps> = ({
  segmentedScores,
  sportCode,
  className
}) => {
  const isMobile = useMediaWidthDown('screen850');
  const {
    mainSegments,
    additionalSegments,
    makeMatchScoreRowTitle
  } = useMatchScores({
    segmentedScores,
    sportCode,
    isMobile,
    PeriodIcon: MobileMatchPeriodIcon,
    gameEventIcons
  });
  const isAdditionalSegments = !!additionalSegments.length;
  if (!mainSegments.length) {
    return null;
  }
  return <PerfectScrollbarWithShadow className={styles.scrollbar} isShowShadow shadowVariant="dark80Shadow" data-sentry-element="PerfectScrollbarWithShadow" data-sentry-component="MatchScores" data-sentry-source-file="MatchScores.tsx">
      <div className={cn(styles.root, className, {
      [styles.mobileView]: isMobile && isAdditionalSegments
    })}>
        {isAdditionalSegments && <MatchAdditionalSegments additionalSegments={additionalSegments} scoreType="HOME" />}

        <div className={styles.segments}>
          {mainSegments.map(([key, scores]) => <MatchScoreRow key={key} stats={scores} title={makeMatchScoreRowTitle(key)} />)}
        </div>

        {isAdditionalSegments && <MatchAdditionalSegments additionalSegments={additionalSegments} scoreType="AWAY" />}
      </div>
    </PerfectScrollbarWithShadow>;
};